import RyderLivescoringModalPortal from "@/components/RyderLivescoring/RyderLivescoringModalPortal"
import React from "react"

const RyderLivescoringTeamDefaultView = ({
    tbd,
    isRight,
    isWinner,
    teamColor,
    showElectronicCard,
    side,
    players,
    showResult,
    isDraw,
    result,
    holeInProgress,
    match,
    modalUrl,
    setModalUrl
}) => {
    if (tbd) {
        return (
            <>
                {/* Desktop */}
                <div className="hidden sm:block w-1/2 p-4">
                    <div
                        className={`font-bold text-2xl text-black xl:text-4xl 2xl:text-6xl ${isRight ? "text-right" : ""}`}>
                        TBD
                    </div>
                </div>
                {/* Mobile */}
                <div className={`sm:hidden p-4 ${isRight ? "border-t border-gray-300" : ""}`}>
                    <div className="font-bold text-xl text-black">TBD</div>
                </div>
            </>
        )
    }

    return (
        <>
            {/* Desktop */}
            <div
                className={`hidden sm:block w-1/2 p-4 relative overflow-visible cursor-pointer transition-colors duration-500 ease-in-out ${isRight ? "pl-14" : ""} ${isWinner ? `team-winner-${teamColor}` : ""}`}
                onClick={() => showElectronicCard(side)}
            >
                {players.map((p, i) => (
                    <div
                        key={i}
                        className={`flex items-center ${i > 0 ? "mt-2" : ""} ${isRight ? "justify-end" : "justify-start"}`}
                    >
                        {isRight ? (
                            <>
                                <div className="text-right mr-2 min-w-0 max-w-[calc(100%-6rem)]">
                                    <div className="font-bold whitespace-normal xl:text-xl 2xl:text-3xl">
                                        {p.name}&nbsp;
                                    </div>
                                    <div className="font-bold whitespace-normal xl:text-xl 2xl:text-3xl">
                                        <p className="inline-block font-normal opacity-50 text-sm sm:text-xs lg:text-sm xl:text-xl 2xl:text-2xl">
                                            {p.surname}
                                        </p>
                                    </div>
                                </div>
                                <div className={`h-10 rounded-full my-2 flex items-center justify-center flex-shrink-0 xl:h-16 2xl:h-18 transition-colors duration-500 ease-in-out team-profile-${teamColor} ${p.imageUrl ? 'w-14 ml-3 xl:w-20 xl:ml-4 2xl:ml-5 2xl:w-22' : 'w-10 mx-3 xl:w-16 xl:mx-4 2xl:mx-5 2xl:w-18'}`}>
                                    {p.imageUrl ? (
                                        <div
                                            className={`w-24 h-16 lg:w-24 lg:h-20 xl:w-28 xl:h-24 player-logo-container team-profile-${teamColor}`}>
                                            <div className="rounded-full overflow-hidden border-2 border-white">
                                                <img
                                                    src={p.imageUrl}
                                                    alt={p.nombre}
                                                    className="w-full h-full object-cover"
                                                />
                                            </div>
                                            <div className={`conceded-points font-bold text-white lg:text-xl xl:text-3xl opacity-80 team-profile-${teamColor}`}>
                                                {p.hcpj}
                                            </div>
                                        </div>
                                    ) : (
                                        <p className="font-bold text-white lg:text-xl xl:text-3xl opacity-80">
                                            {p.hcpj}
                                        </p>
                                    )}
                                </div>
                            </>
                        ) : (
                            <>
                                <div className={`h-10 rounded-full my-2 flex items-center justify-center flex-shrink-0 xl:h-16 2xl:h-18 transition-colors duration-500 ease-in-out team-profile-${teamColor} ${p.imageUrl ? 'w-14 mr-3 xl:w-20 xl:mr-4 2xl:mr-5 2xl:w-22' : 'w-10 mx-3 xl:w-16 xl:mx-4 2xl:mx-5 2xl:w-18'}`}>
                                    {p.imageUrl ? (
                                        <div
                                            className={`w-24 h-16 lg:w-24 lg:h-20 xl:w-28 xl:h-24 player-logo-container team-profile-${teamColor}`}>
                                            <div className="rounded-full overflow-hidden border-2 border-white">
                                                <img
                                                    src={p.imageUrl}
                                                    alt={p.nombre}
                                                    className="w-full h-full object-cover"
                                                />
                                            </div>
                                            <div className={`conceded-points font-bold text-white lg:text-xl xl:text-3xl opacity-80 team-profile-${teamColor}`}>
                                                {p.hcpj}
                                            </div>
                                        </div>
                                    ) : (
                                        <p className="font-bold text-white lg:text-xl xl:text-3xl opacity-80">
                                            {p.hcpj}
                                        </p>
                                    )}
                                </div>
                                <div className="min-w-0">
                                    <div className="font-bold whitespace-normal xl:text-xl 2xl:text-3xl">
                                        {p.name}&nbsp;
                                    </div>
                                    <div className="font-bold whitespace-normal xl:text-xl 2xl:text-3xl">
                                        <p className="inline-block font-normal opacity-50 text-sm sm:text-xs lg:text-sm xl:text-xl 2xl:text-2xl">
                                            {p.surname}
                                        </p>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                ))}

                {showResult && (
                    <>
                        <div className={`absolute inset-y-0 ${isRight ? "left-0" : "right-0"} w-2 bg-white z-10`}/>
                        <div
                            className={`absolute inset-y-0 ${isRight ? "left-5" : "right-5"} flex flex-col mb-1 items-center justify-center z-20`}>
                            <div
                                className={`font-bold text-2xl px-4 py-1 xl:text-2xl 2xl:text-3xl ${isRight ? "rounded-l-md" : "rounded-r-md"} ${isDraw ? "text-black bg-white" : ""}`}>
                                {result}
                            </div>
                            <div className="text-xs xl:text-lg 2xl:text-xl opacity-60 uppercase">
                                <p>{holeInProgress(match)}</p>
                            </div>
                        </div>
                    </>
                )}
            </div>

            {/* Mobile */}
            <div
                className={`sm:hidden relative p-4 transition-colors duration-500 ease-in-out ${isRight ? "border-t border-gray-300 pr-12" : ""} ${isWinner ? `team-winner-${teamColor}` : ""}`}
                onClick={() => showElectronicCard(side)}
            >
                {players.map((p, i) => (
                    <div
                        key={i}
                        className={`flex items-center ${i > 0 ? "mt-2" : ""}`}
                    >
                        <div
                            className={`w-8 h-8 rounded-full mr-2 flex items-center justify-center flex-shrink-0 transition-colors duration-500 ease-in-out team-profile-${teamColor}`}
                        >
                            {p.imageUrl ? (
                                <div className={`player-logo-container w-full h-full`}>
                                    <p className="font-semibold text-white conceded-points">
                                        {p.hcpj}
                                    </p>
                                    <img
                                        src={p.imageUrl}
                                        alt={p.nombre}
                                        className=" object-cover rounded-full"
                                    />
                                </div>
                            ) : (
                                <p className="font-semibold text-white">
                                    {p.hcpj}
                                </p>
                            )}
                        </div>
                        <div className="min-w-0">
                            <div className="font-bold whitespace-normal">
                                {p.name}&nbsp;
                                <p className="inline-block text-sm opacity-60">
                                    {p.surname}
                                </p>
                            </div>
                        </div>
                    </div>
                ))}

                {showResult && (
                    <>
                        <div
                            className={`absolute inset-y-0 ${isRight ? "left-0" : "right-0"} w-1 bg-white z-10`}
                        />
                        <div className="absolute inset-y-0 right-4 flex flex-col mb-1 items-center justify-center z-20">
                            <div
                                className={`font-bold text-xl px-3 py-1 ${isRight ? "rounded-l-md" : "rounded-r-md"} ${isDraw ? "text-black bg-white" : ""}`}>
                                {result}
                            </div>
                            <div className="text-xs font-bold opacity-60 uppercase">
                                <p>{holeInProgress(match)}</p>
                            </div>
                        </div>
                    </>
                )}
            </div>
            {modalUrl && (
                <RyderLivescoringModalPortal>
                    <div
                        onClick={() => setModalUrl(null)}
                        className="fixed inset-0 z-50 flex items-center justify-center bg-stone-900"
                    >
                        <div
                            onClick={(e) => e.stopPropagation()}
                            className="relative bg-white rounded-lg shadow-2xl overflow-hidden"
                            style={{
                                width: 'calc(100% - 2rem)',
                                maxWidth: '48em',
                                height: '90vh',
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <div className="flex justify-end items-start p-2 bg-white border-b border-gray-200">
                                <button
                                    onClick={setModalUrl.bind(null, null)}
                                    className="cursor-pointer w-10 h-10 rounded-full border border-gray-300 bg-white flex items-center justify-center text-3xl text-slate-600 hover:text-slate-800 shadow transition"
                                    aria-label="Cerrar"
                                >
                                    ×
                                </button>
                            </div>

                            <div className="flex-1">
                                <iframe
                                    src={modalUrl}
                                    title="Tarjeta electrónica"
                                    className="w-full h-full"
                                    allowFullScreen
                                />
                            </div>
                        </div>
                    </div>
                </RyderLivescoringModalPortal>
            )}
        </>
    )
}

export default RyderLivescoringTeamDefaultView
